import { createContext } from "react";

interface InstallationContextProps {
  isInstalled: boolean | undefined;
  plan: "base" | "avanzato" | null | undefined;
  isLoading: boolean;
  isError: boolean;
}

export const InstallationContext = createContext<InstallationContextProps | undefined>(undefined);
